<template>
  <TemplateBackground>
    <template v-slot:label>
      <component :is="'p'" class="flex justify-center flex-col max-w-[960px] mx-auto">
        <p class="inline" v-if="$route.query.form">
          Olá! Bem vindo a página de <b class="uppercase">cadastro de empresas fornecedores de produtos e serviços.</b> Preencha os dados abaixo e clique em REGISTRAR. É necessário informar um e-mail válido, pois você receberá um link de ativação do cadastro pelo e-mail. Na mensagem do e-mail de ativação haverá também um link para o preenchimentos das informações da sua empresa.
        </p>

        <p class="inline" v-else>
          Para visualizar os fornecedores de produtos e serviços, faça seu cadastro preenchendo os campos abaixo. Após o cadastro você receberá um link de ativação no e-mail informado no cadastro. Verifique sua caixa postal e clique no link disponível no e-mail. Caso o e-mail não esteja na sua caixa de entrada verifique se ela não está no SPAM.
    Após confirmação do seu cadastro é só fazer o login no sistema e pesquisar pelos fornecedores de produtos e serviços cadastrados no sistema.
        </p>
      </component>
    </template>

    <template v-slot:content>
      <template v-if="!isDone">
        <div class="mt-2">
          <Input
            name="name"
            type="text"
            :placeholder="'Nome'"
            autocomplete="off"
            :value="formData.name"
            :on-change="(value) => formData.name = value"
            validate-with-on-blur
            :validate="(value) => strMin(value, 4)"
            :on-validate="(value) => formDataValidate.name = value"
            :helper-text="'Nome deve conter no mínimo 4 letras.'"
            :helper-text-class="'text-white bg-orange-400 p-1 rounded-md'"
            :validate-on-update="isValideAll"
          />
        </div>

        <template v-if="!$route.query.form">
          <div class="mt-2">
            <Input
              name="CNPJ"
              type="text"
              placeholder="CNPJ"
              :value="formData.cnpj"
              autocomplete="off"
              :on-change="(value) => formData.cnpj = value"
              validate-with-on-blur
              :validate="(value) => useValidations('cnpj', value)"
              :on-validate="(value) => formDataValidate.cnpj = value"
              :helper-text="'CNPJ inválido.'"
              :helper-text-class="'text-white bg-orange-400 p-1 rounded-md'"
              :validate-on-update="isValideAll"
            />
          </div>

          <div class="mt-2">
            <Input
              name="Razão Social"
              type="text"
              placeholder="Razão Social"
              :value="formData.socialName"
              autocomplete="off"
              :on-change="(value) => formData.socialName = value"
              validate-with-on-blur
              :validate="(value) => strMin(value, 4)"
              :on-validate="(value) => formDataValidate.socialName = value"
              :helper-text="'Razão social deve conter no mínimo 4 letras.'"
              :helper-text-class="'text-white bg-orange-400 p-1 rounded-md'"
              :validate-on-update="isValideAll"
            />
          </div>
        </template>

        <div class="mt-2">
          <Input
            name="email"
            type="text"
            autocomplete="off"
            :placeholder="'E-mail'"
            :value="formData.email"
            :on-change="(value) => formData.email = value"
            validate-with-on-blur
            :validate="value => useValidations('email', value)"
            :on-validate="(value) => formDataValidate.email = value"
            :helper-text="'E-mail inválido.'"
            :helper-text-class="'text-white bg-orange-400 p-1 rounded-md'"
            block-copy
            :validate-on-update="isValideAll"
          />
        </div>

        <div class="mt-2">
          <Input
            name="confirm-email"
            type="text"
            autocomplete="off"
            :placeholder="'Confirmar e-mail'"
            :value="confirmEmail"
            :on-change="(value) => confirmEmail = value"
            validate-with-on-blur
            :validate="() => confirmEmail === formData.email"
            :on-validate="(value) => formDataValidate.confirmEmail = value"
            :helper-text="'E-mail não confere.'"
            :helper-text-class="'text-white bg-orange-400 p-1 rounded-md'"
            block-paste
            :validate-on-update="isValideAll"
          />
        </div>

        <div class="mt-2">
          <Input
            name="password"
            type="password"
            autocomplete="off"
            :placeholder="'Senha'"
            :value="formData.passwd"
            :on-change="(value) => formData.passwd = value"
            validate-with-on-blur
            :validate="(value) => strMin(value, 4)"
            :on-validate="(value) => formDataValidate.passwd = value"
            :helper-text="'Senha deve conter no mínimo 4 caracteres.'"
            :helper-text-class="'text-white bg-orange-400 p-1 rounded-md'"
            block-copy
            :validate-on-update="isValideAll"
          />
        </div>

        <div class="mt-2">
          <Input
            name="confirm-password"
            type="password"
            autocomplete="off"
            :placeholder="'Confirmar senha'"
            :value="confirmPassword"
            :on-change="(value) => confirmPassword = value"
            validate-with-on-blur
            :validate="() => confirmPassword === formData.passwd"
            :on-validate="(value) => formDataValidate.confirmPassword = value"
            :helper-text="'Senha não confere'"
            :helper-text-class="'text-white bg-orange-400 p-1 rounded-md'"
            block-paste
            :validate-on-update="isValideAll"
          />
        </div>
      </template>

      <Message v-if="statusResponse === 409" class="mt-10" type="warn">
        <NuxtLink to="/" class="font-semibold">Este email possui cadastro. Clique aqui para fazer entrar</NuxtLink>
      </Message>

      <Message v-if="statusResponse === 406" class="mt-10" type="warn">
        <NuxtLink to="/" class="font-semibold">Este CNPJ possui cadastro. Clique aqui para fazer entrar</NuxtLink>
      </Message>

      <Message v-else-if="!statusResponse" class="mt-10" type="warn">
        Verifique sua conexão e tente novamente.
      </Message>

      <div v-if="statusResponse !== 200 && statusResponse !== 201">
        <Button
          class="bg-secondary-500"
          @click="onSend"
          :is-loading="isLoading"
          loading-size="md"
          is-width-full
        >
          Registrar
        </Button>
      </div>

      <p v-if="statusResponse === 200 || statusResponse === 201"
        class="mt-10 text-center text-sm text-white bg-green-500 rounded-sm p-4 transform"
      >
        Para continuar acesse o link enviado pelo email.
      </p>

      <p class="mt-5 text-center text-lg text-white">
        Já possui cadastro?
        <a href="/login" class="font-semibold hover:text-second"><b>Clique aqui para entrar</b></a>
      </p>
    </template>

  </TemplateBackground>
</template>

<script lang="ts" setup>
import { AxiosError, } from "axios";

definePageMeta({ middleware: ["auth"] });

const route = useRoute();

const statusResponse = ref(-1);
const isLoading = ref(false);
const confirmPassword = ref("");
const confirmEmail = ref("");
const isValideAll = ref(false);
const isDone = ref(false);

const formData = reactive<CreateUser>({
  name: "",
  cnpj: undefined,
  socialName: undefined,
  email: "",
  passwd: "",
  type: 3
});

const formDataValidate = reactive({
  name: true,
  email: true,
  passwd: true,
  cnpj: false,
  socialName: false,
  confirmPassword: true,
  confirmEmail: true
});

const { dispatch } = useUser();

function resetForm(){
  formData.name = "";
  formData.email = "";
  formData.passwd = "";
  confirmEmail.value = "";
  confirmPassword.value = "";
}

function onSend(){
  isValideAll.value = true;

  if (!validateFormData(formDataValidate)) return;

  isLoading.value = true;

  if(route.query.form){
    formData.type = 1;
    delete formData.cnpj;
    delete formData.socialName;
  }else{
    formData.type = 3;
  }

  dispatch(formData)
    .then((res) => {
      statusResponse.value = res.status;
      resetForm();
      isDone.value = true;
    })
    .catch((err: AxiosError) => {
      statusResponse.value = err?.response?.status ?? 0;
    }).finally(() => {
      isLoading.value = false;
    });
}

useHead({ title: route.query.form ? "Cadastre sua empresa" : "Cadastro de usuário" });

</script>